<!-- Deliberately NOT p-carousel. Its wrappers bind an inline height that beats
     any stylesheet rule, so the dots could not be pinned to the bottom. One
     slide rendered directly is less code and fully ours to lay out. -->
<div class="release-notes-modal" [class.is-fullscreen]="fullscreen">

  <div class="release-stage">
    <button *ngIf="slides.length > 1" type="button"
      class="release-nav release-nav-prev"
      [disabled]="!hasPrev"
      aria-label="Previous slide"
      (click)="prev()">
      <i class="pi pi-chevron-left"></i>
    </button>

    <div class="release-slide" [innerHTML]="slides[page]"></div>

    <button *ngIf="slides.length > 1" type="button"
      class="release-nav release-nav-next"
      [disabled]="!hasNext"
      aria-label="Next slide"
      (click)="next()">
      <i class="pi pi-chevron-right"></i>
    </button>
  </div>

  <div *ngIf="slides.length > 1" class="release-dots">
    <button *ngFor="let slide of slides; let i = index" type="button"
      class="release-dot"
      [class.is-active]="i === page"
      [attr.aria-label]="'Go to slide ' + (i + 1)"
      [attr.aria-current]="i === page"
      (click)="goTo(i)"></button>
  </div>

  <div class="release-footer flex align-items-center justify-content-between flex-wrap gap-2">
    <span class="text-600 text-sm">
      {{ meta }}<ng-container *ngIf="slides.length > 1"><ng-container *ngIf="meta"> · </ng-container>Slide {{ page + 1 }} of {{ slides.length }}</ng-container>
    </span>

    <div class="flex gap-2">
      <button pButton pRipple type="button"
        [icon]="fullscreen ? 'pi pi-window-minimize' : 'pi pi-window-maximize'"
        [pTooltip]="fullscreen ? 'Exit full screen' : 'Full screen'"
        class="p-button-text p-button-secondary"
        (click)="toggleFullscreen()"></button>
      <button pButton pRipple type="button"
        [label]="updatePending ? 'Later' : 'Close'"
        class="p-button-secondary"
        (click)="onClose()"></button>
      <button *ngIf="updatePending" pButton pRipple type="button"
        label="Update now" icon="pi pi-refresh"
        (click)="onUpdateNow()"></button>
    </div>
  </div>

</div>
